<template>
  <mu-container class="container demo-text animated slideInDown">
    <mu-paper class="demo-list-wrap">
      <mu-list v-if="typeof data !== 'string'" textline="two-line">
        <div v-for="item in data" :key="item.id">
          <mu-list-item
            :ripple="false"
            :to="{
              path: '/historical-answer',
              query: { answer_id: item.id, type: 'wrong' },
            }"
            avatar
            button
          >
            <mu-list-item-content>
              <mu-list-item-title>{{ item.title }}</mu-list-item-title>
              <mu-list-item-sub-title>
                错题数:
                <span>{{ item.num }}</span>
              </mu-list-item-sub-title>
            </mu-list-item-content>
            <mu-list-item-action>
              <mu-list-item-after-text>
                {{ item.end_time }}
              </mu-list-item-after-text>
              <!-- <mu-badge :content="item.type === 3 ? '模拟考试' : '模拟考试'"></mu-badge> -->
            </mu-list-item-action>
          </mu-list-item>
          <mu-divider></mu-divider>
        </div>
      </mu-list>
      <div v-if="showError" class="bg-info">
        <br />
        <br />
        <br />
        <mu-icon size="96" value="info" color="info"></mu-icon>
        <p class="text-center">暂无错题</p>
      </div>
    </mu-paper>
  </mu-container>
</template>

<script>
import { fetchMistakeCollectionList } from '@/api/index'

export default {
  components: {},
  props: {},
  data() {
    return {
      data: '',
      showError: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    this.data = await fetchMistakeCollectionList().catch(
      () => (this.showError = true)
    )
    if (Array.isArray(this.data) && this.data.length <= 0) {
      this.showError = true
    }
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {},
  filter: {},
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  padding: {
    left: 0;
    right: 0;
  }
}
.mu-list {
  padding: 0;
}
</style>
<style lang="scss">
.demo-text {
  //   padding: 16px;
  background: #fff;
  p {
    margin: 8px 0;
  }
}
</style>
